






























































































































import Vue from 'vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import { CourseBoardsModel } from '@descomplica/dex-models';

const DEFAULT_CLASSROOM = {
  id: null,
  name: '',
  description: '',
};

export default Vue.extend({
  components: {
    TrashCanOutlineIcon,
    ArrowRightIcon,
    SquareEditOutlineIcon,
    pxCard,
    pxModal,
    pxButton,
  },

  props: {
    course: {
      type: Object,
      required: true,
    },
    courseBoards: {
      type: Array,
      required: true,
    },
    group: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    const newClassroom = Object.assign({}, DEFAULT_CLASSROOM);
    return {
      currentEditingClassroom: null,
      isSavingClassroom: false,
      isSavingBoard: false,
      newClassroom,
      oldClassroom: null,
      editBoard: false,
    };
  },

  methods: {
    openBoardEditorModal(courseBoard: CourseBoardsModel) {
      this.editBoard = !this.editBoard;
      this.description = courseBoard.description;
      this.boardId = courseBoard.board.id;
      this.suggestedPeriod = courseBoard.suggestedPeriod;
      this.editedCourseBoardId = courseBoard.id;
    },
    closeBoardEditorModal() {
      this.editBoard = !this.editBoard;
      this.description = null;
      this.boardId = null;
      this.suggestedPeriod = null;
      this.editedCourseBoardId = null;
    },

    async editCourseBoard() {
      if (this.isSavingBoard) return;
      this.isSavingBoard = true;
      const courseBoard = {
        id: this.editedCourseBoardId,
        description: this.description,
        suggestedPeriod: parseInt(this.suggestedPeriod),
      };
      await this.$store.dispatch('PUSH_COURSE_BOARD_BY_ID', courseBoard);
      await this.$store.dispatch('PULL_COURSE', this.course.id);
      this.closeBoardEditorModal();
      this.isSavingBoard = false;
    },
    async removeBoardInGroup(boardId, group) {
      if (!group) return;
      const boardIds = group.boardIds.filter(id => {
        return id != boardId;
      });
      if (confirm('Tem certeza que deseja deletar esse mural do grupo?')) {
        await this.$store.dispatch('UPDATE_GROUP', {
          groupId: group.id,
          groupInfo: { boardIds },
        });
        await this.$store.dispatch(
          'PULL_BOARDS_GROUPS_BY_COURSE_ID',
          this.course.id,
        );
      }
    },

    verifyIfCanAddClassroom(courseBoard) {
      if (this.course.descomplicaCategorySlug !== 'pos') return true;
      return courseBoard.board.classrooms.length === 0;
    },
    async deleteCourseBoard(courseBoardId: CourseBoardsModel) {
      if (confirm('Tem certeza que deseja deletar essa associação de mural?')) {
        await this.$store.dispatch('DELETE_COURSE_BOARD', courseBoardId);
        await this.$store.dispatch('PULL_COURSE', this.course.id);
      }
    },

    updateCourseBoardRelation(courseBoard) {
      if (this.group) {
        this.removeBoardInGroup(courseBoard.boardByBoardId.id, this.group);
      } else {
        this.deleteCourseBoard(courseBoard.id);
      }
    },

    toggleClassroomEditor(
      classroom: any,
      courseBoard?: CourseBoardsModel,
      isEditting?: boolean,
    ) {
      if (!classroom) {
        this.cancelEdittingClassroom();
        return;
      }

      const canAddClassroom = this.verifyIfCanAddClassroom(courseBoard);

      if (!isEditting && (this.isSavingClassroom || !canAddClassroom)) return;

      this.setEditClassroomModalParams(classroom, courseBoard.board.id);
    },
    cancelEdittingClassroom() {
      if (this.oldClassroom) this.restoreCurrentEditingClassroom();
      this.currentEditingClassroom = null;
      this.resetNewClassroom();
    },

    setEditClassroomModalParams(classroom: any, boardId?: number) {
      this.oldClassroom = Object.assign({}, classroom);

      this.currentEditingClassroom = classroom;
      if (boardId) this.currentEditingClassroom.boardId = boardId;
    },

    async editClassroom() {
      if (this.isSavingClassroom) return;
      this.isSavingClassroom = true;

      if (this.currentEditingClassroom.id) {
        await this.$store.dispatch(
          'PUSH_CLASSROOM',
          this.currentEditingClassroom,
        );
      } else {
        const wasCreatedSuccessfully = await this.$store.dispatch(
          'CREATE_CLASSROOM_AND_BOARDS_CLASSROOM',
          {
            classroom: this.currentEditingClassroom,
            courseId: this.course.id,
            boardId: this.currentEditingClassroom.boardId,
          },
        );
        this.resetNewClassroom();
        if (wasCreatedSuccessfully)
          await this.$store.dispatch('PULL_COURSE', this.course.id);
      }

      this.currentEditingClassroom = null;
      this.isSavingClassroom = false;
    },

    resetNewClassroom() {
      this.newClassroom = Object.assign({}, DEFAULT_CLASSROOM);
    },

    restoreCurrentEditingClassroom() {
      this.currentEditingClassroom.name = this.oldClassroom.name;
      this.currentEditingClassroom.description = this.oldClassroom.description;
    },
  },
});
